module.exports = __webpack_public_path__ + "static/media/boy-6.3844105d.svg";